import {getAuthUser} from "../utils";

export default{
	computed:{
		authenticatedUser(){
			let authUser = this.$session.get("authUser") || {};
			return getAuthUser(authUser);
		}
	}
}
